//@ts-check
import { initStaffLogin } from './staff-login.action';

export default (state = {
  staffOrder: '',
  staffList: []
}, action) => {
  if (action.type === String(initStaffLogin)) {
    return action.payload;
  }
  return state;
};